<template>
  <div class="homePage">
    <div>
      <img src="@/assets/image/workbanner.jpg" style="width:100%" alt=""/>
    </div>
    <div class="pagew mid">
      <div class="guide" v-show="false">
        <span style="cursor:pointer" @click="back">{{ type }}</span>
        <span>{{ title }}</span>
      </div><br>
      <h2 style="align-content: center">{{ title }}</h2>
      <div class="news-info"><span>{{ time }}</span><span>{{ writer }}</span><span>{{ competitiontile }}</span></div>
      <div class="content" v-html="html">
      </div>
      <div class="news-info" v-if="file != '' && file != null">附件下载：
        <el-link :href="filepath" style="color: #044fa6;font-size: 16px" target="_blank" >点击查看下载附件</el-link>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/index";
import * as request from '@/api/api.js'
import {getNewsListDetails} from "@/api/api.js";


export default {
  // components: {Footer, Header},
  data() {
    return {
      title: '',
      type: '',
      writer: '',
      time: '',
      file: '',
      filepath: '',
      html: '',
      competitiontile: ''
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      request.getNewsListDetails({newsId:204}).then(res=>{
        this.html = res.data.intro;

        this.title = res.data.title;
        this.writer = res.data.writer;
        this.time = res.data.time;
        this.file = res.data.file;
        this.filepath = 'http://admin.gdsme.org/dev-api' + res.data.file;
        // this.filepath = 'http://' + this.$serverAddress + '/dev-api' + res.data.file;
        if (res.data.type == 1) this.type = '赛事公告';
        if (res.data.type == 2) this.type = '新闻报道';
        if (res.data.type == 3) this.type = '产业对接';
        if (res.data.type == 4) this.type = '扶持政策';
        this.competitiontile = res.data.competitiontile;
      })
    },
    go(code) {
      this.index = code;
    },
    back() {
      this.$router.push({
        path: '/news'
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.list ::v-deep .el-pagination .el-pager li .active {
  background-color: #044fa6 !important;
}

.homePage {
  width: 100%;

  .mid {
    padding: 40px 0;
  }

  .guide {
    text-align: start;
    color: #999;

    font-size: 14px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: start;
    margin-top: 35px;
  }

  .content {
    margin-top: 35px;
    text-align: start;

    .content-text {
      margin-top: 40px;
      margin-bottom: 40px;
    }
  }


  .el-carousel__item .is-active {
    :deep(.is-active) {
      background-color: #044fa6;
    }

  }

  .el-carousel__item:nth-child(2n) {
    // background-color: gray;
  }

  .el-carousel__item:nth-child(2n+1) {
    // background-color: gray;
  }

  .news-info {
    margin-top: 20px;
    text-align: start;
  }
  .news-info span {
    display: inline-block; margin-right: 18px;font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Match/index.vue